interface Headers {
  'content-disposition'?: string
}

export function getFileNameFromResponseHeader(headers: Headers, defaultName: string): string {
  const contentDisposition = headers['content-disposition'];
  const fileName = contentDisposition?.split('=')[1];
  return fileName || defaultName;
}
